import dstoreOrder from "../services/dstore.orders";
import notification from "../services/notification";
import advanceSearchHelper from "../services/advance.search.helper";

export default {
    namespaced: true,
    state: {
        loading: false,
        orders: [],
        errors: null,
        maxPage: 1,
        nextPage: 0,
        prevPage: 0,
        currentPage: 1,
        searchableFields: [],
        statusSearchOptions: [],
        defaultStatusSearchOption: null,
        defaultSearchableFieldOption: null,
        searchKeyword: null,
        pagination: {
            currentPage: 1,
            prevPage: 0,
            nextPage: 0,
            maxPage: 0,
            totalPerPage: 1,
            currentFirstItem: 1,
            currentLastItem: 1,
            initialPageCount: 0,
            perPage: 10
        },
        modal: {
            view_order: {
                status: false
            },
            view_deposit_slip_image: {
                status: false
            }
        },
        orderDetails: null,
        depositSlipImage: null,
        orderTransactionUuid: null,
        paymentTypeOptions: null,
        logisticsTypeOptions: null
    },
    mutations: {
        loading(state, value = true) {
            state.loading = value;
        },
        errors(state, errors) {
            state.errors = errors;
            state.loading = false;
        },
        resetErrors(state) {
            state.errors = null;
        },
        orders(state, list) {
            state.orders = list;
        },
        pagination(state, pagination) {
            state.maxPage = pagination.max_page;
            state.prevPage = pagination.prev_page;
            state.nextPage = pagination.next_page;
            state.currentPage = state.prevPage + 1;
        },
        setInitialPageCount(state, list) {
            state.pagination.initialPageCount = list.length;
        },
        setCurrentPage(state, page) {
            state.pagination.currentPage = page;
        },
        setPagination(state, pagination) {
            state.pagination.totalPerPage = pagination.list.length;
            state.pagination.maxPage =
                state.pagination.totalPerPage > 0 ? pagination.max_page : 0;
            state.pagination.prevPage = pagination.prev_page;
            state.pagination.nextPage = pagination.next_page;
            state.pagination.currentPage = state.pagination.prevPage + 1;
            state.pagination.currentFirstItem =
                state.pagination.totalPerPage > 0
                    ? state.pagination.initialPageCount *
                          state.pagination.prevPage +
                      1
                    : 0;
            state.pagination.currentLastItem =
                state.pagination.currentFirstItem > 0
                    ? state.pagination.currentFirstItem +
                      state.pagination.totalPerPage -
                      1
                    : 0;
        },
        searchableFields(state, fields) {
            state.searchableFields = fields;
            state.defaultSearchableFieldOption = fields[0].value;
        },
        statusSearchOptions(state, options) {
            state.statusSearchOptions = options;
            state.defaultStatusSearchOption = options[0].value;
        },
        defaultStatusSearchOption(state, value) {
            state.defaultStatusSearchOption = value;
        },
        defaultSearchableFieldOption(state, value) {
            state.defaultSearchableFieldOption = value;
        },
        searchKeyword(state, value) {
            state.searchKeyword = value;
        },
        setModal(state, param) {
            state.modal[param.type].status = param.status;
        },
        setDepositSlipImage(state, param) {
            state.depositSlipImage = param;
        },
        orderDetails(state, orderDetails) {
            state.orderDetails = orderDetails;
        },
        orderTransactionUuid(state, orderTransactionUuid) {
            state.orderTransactionUuid = orderTransactionUuid;
        },
        paymentTypeOptions(state, paymentTypeOptions) {
            state.paymentTypeOptions = paymentTypeOptions;
        },
        logisticsTypeOptions(state, logisticsTypeOptions) {
            state.logisticsTypeOptions = logisticsTypeOptions;
        }
    },
    actions: {
        async getOrders({ commit }, param) {
            commit("loading");
            try {
                let response = await dstoreOrder
                    .getOrders(param)
                    .then(function(response) {
                        return response.data.orders;
                    });

                commit("orders", response.list);
                commit("setPagination", response);
                commit("loading", false);
            } catch (errors) {
                notification.warning("Oops, cannot retrieve orders.");
                commit("errors", errors);
                commit("loading", false);
            }
        },
        async exportHistory({ commit }, param) {
            commit("loading");
            try {
                let response = await dstoreOrder.exportHistory(param);
                notification.success(response.message);
                commit("loading", false);
            } catch (errors) {
                notification.warning(
                    "Oops, cannot update deposit slip status."
                );
                commit("errors", errors);
                commit("loading", false);
            }
        },
        async getStatusOption({ commit }) {
            commit("loading");
            try {
                let response = await dstoreOrder
                    .getStatusOption()
                    .then(function(response) {
                        return response.data;
                    });
                console.log(response);
                let statusOptions = advanceSearchHelper.buildOptionFor(
                    response.status,
                    "All Status"
                );

                console.log(statusOptions);

                commit("statusSearchOptions", statusOptions);
                commit("loading", false);
            } catch (errors) {
                commit("errors", errors);
                commit("loading", false);
            }
        },
        async getSearchableFieldsOption({ commit }) {
            try {
                let response = await dstoreOrder.getColumnsOption();
                // console.log(response)
                let columnOptions = advanceSearchHelper.buildOptionFor(
                    response.options,
                    null
                );
                let paymentTypeOptions = advanceSearchHelper.buildOptionFor(
                    response.payment_type_options,
                    null
                );
                let logisticsTypeOptions = advanceSearchHelper.buildOptionFor(
                    response.logistics_type_options,
                    null
                );

                // Remove Mode of Payment and Logistics Type in column options
                // columnOptions.splice(-2)

                // let branchOriginOption = columnOptions.find(
                //     status => status.text === "Branch origin"
                // );
                // branchOriginOption.text = "Brand Branch";
                console.log(columnOptions);
                commit("searchableFields", columnOptions);
                commit("paymentTypeOptions", paymentTypeOptions);
                commit("logisticsTypeOptions", logisticsTypeOptions);
            } catch (errors) {
                commit("errors", errors);
            }
        },
        async updateStatus({ commit }, param) {
            commit("loading");
            try {
                let response = await dstoreOrder.updateStatus(param);
                notification.success(response.message);
                commit("loading", false);
            } catch (errors) {
                notification.warning("Oops, cannot update order.");
                commit("errors", errors);
                commit("loading", false);
            }
        },
        async cancelOrder({ commit }, param) {
            commit("loading");
            try {
                let response = await dstoreOrder.cancelOrder(param);
                notification.success(response.message);
                commit("loading", false);
            } catch (errors) {
                notification.warning("Oops, cannot cancel order.");
                commit("errors", errors);
                commit("loading", false);
            }
        },
        async getOrderTransactionDetails({ commit }, param) {
            commit("loading");
            try {
                // console.log(param);
                let orderDetails = await dstoreOrder
                    .getOrderTransactionDetails(param)
                    .then(function(response) {
                        return response.data.order;
                    });
                commit("orderTransactionUuid", param.uuid);
                console.log(orderDetails);
                commit("orderDetails", orderDetails);
                commit("loading", false);
            } catch (errors) {
                notification.warning(
                    "Oops, cannot retrieve transaction details."
                );
                commit("errors", errors);
                commit("loading", false);
            }
        },
        async updateDepositSlipStatus({ commit }, param) {
            commit("loading");
            try {
                let response = await dstoreOrder.updateDepositSlipStatus(param);
                notification.success(response.message);
                commit("loading", false);
            } catch (errors) {
                notification.warning(
                    "Oops, cannot update deposit slip status."
                );
                commit("errors", errors);
                commit("loading", false);
            }
        }
    }
};
